import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import SiteDateSelector from "../SiteDateSelector";
import { getUrlParameterByName, splitNumber } from "../../../utils/utility";
import isUndefined from "lodash/isUndefined";
import map from "lodash/map";
import take from "lodash/take";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import filter from "lodash/filter";
import Select from "react-select";
import queryString from "querystring";
import AlertError from "material-ui/svg-icons/alert/error";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";

import "../insights.css";

class InsightPopularPagesIndex extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageCount: 20,
      filter: "",
      errorKey: "",
      mostPopularPages: undefined,
      showEmptyError: false,
    };
  }

  componentDidMount() {
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    if (tagId > 0 && clientId > 0) {
      this.props.getClientSites(clientId);
      this.props.selectClient(clientId);
      this.props.setWebsiteId(tagId);
      this.props.fetchMostPopularPages(tagId, this.props.dayRange);
    } else if (clientId > 0 && isEmpty(tagId)) {
      this.props.getClientSites(clientId);
      this.props.selectClient(clientId);
      if (this.props.websiteId && this.props.fetchFavoritePages) {
        this.props.fetchFavoritePages(this.props.websiteId);
      }
    } else {
      this.props.selectClient(this.props.selected_client);
    }
  }

  componentWillReceiveProps(nextProps) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    let alreadyFetch = false;
    if (nextProps.client_info) {
      if (nextProps.client_info.subscriptionTierId < 4) {
        this.props.history.push("/");
      }
    }

    if (nextProps.selected_client !== this.props.selected_client) {
      if (
        nextProps.selected_client !== clientId &&
        nextProps.selected_client > 1
      ) {
        window.location.href =
          "/distribution/pages/popular?cid=" + nextProps.selected_client;
      }
      this.props.getClientInfo(nextProps.selected_client);
    }
    /*
    if (nextProps.websiteId !== this.props.websiteId) {
      if (nextProps.websiteId > 0) {
        if (tagId !== nextProps.websiteId) {
          const url =
            "/distribution/pages/popular?cid=" +
            clientId +
            "&tag=" +
            nextProps.websiteId;
          window.location.href = url;
        } else {
          if (this.props.dayRange) {
            alreadyFetch = true;
            this.props.fetchMostPopularPages(tagId, nextProps.dayRange);
          }
        }
      }
    }*/

    if (isUndefined(nextProps.websiteId) && tagId > 0) {
      this.props.setWebsiteId(tagId);
    }

    if (!isEqual(nextProps.mostPopularPages, this.props.mostPopularPages)) {
      this.setState({
        filter: "",
        pageCount: 20,
      });
    }

    if (nextProps.dayRange !== this.props.dayRange) {
      this.props.fetchMostPopularPages(tagId, nextProps.dayRange);
    }

    if (!isEqual(nextProps.mostPopularPages, this.props.mostPopularPages)) {
      this.setState({ mostPopularPages: nextProps.mostPopularPages });
    }
    if (nextProps.favoriting !== this.props.favoriting) {
      if (!nextProps.favoriting && this.state.errorKey) {
        const pages = nextProps.mostPopularPages;
        for (var i = 0; i < pages.length; i++) {
          if (
            pages[i].pageUrl === this.state.errorKey &&
            !nextProps.setFavoriteError
          ) {
            pages[i].favorite = !pages[i].favorite;
          }
        }
        this.setState({ mostPopularPages: pages });
      }
    }
    if (nextProps.loadingPopularPages !== this.props.loadingPopularPages) {
      if (!nextProps.loadingPopularPages && this.props.loadingPopularPages)
        this.setState({
          showEmptyError: true,
        });
      else
        this.setState({
          showEmptyError: false,
        });
    }
  }
  onWebSiteIdChanged(id) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    this.props.setWebsiteId(clientId);
    window.location.href =
      "/distribution/pages/popular?cid=" + clientId + "&tag=" + id;
  }
  render() {
    const {
      websiteId,
      setDateRange,
      dayRange,
      client_sites,
      loadingPopularPages,
      loadingPopularPagesError,
      favoriting,
      setFavoriteError,
    } = this.props;
    const pages = take(this.state.mostPopularPages, this.state.pageCount);
    const pageList = map(pages, page => {
      return { value: page.pageUrl, label: page.pageUrl };
    });
    const filterPages = isEmpty(this.state.filter)
      ? pages
      : filter(pages, page => {
          return page.pageUrl.indexOf(this.state.filter) >= 0;
        });

    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const cid = parseInt(getUrlParameterByName("cid"), 10);
    const type = getUrlParameterByName("type")
      ? getUrlParameterByName("type")
      : "default";
    const urlParams = queryString.parse(this.props.location.search);
    const containerheight = this.state.pageCount === 20 ? "auto" : "800px";
    return (
      <div id="segment-distribution-container">
        <div
          style={{
            margin: "-20px 10% 20px",
            fontSize: "16px",
            borderBottom: "solid 1px #EEEFF2",
          }}
        >
          <SiteDateSelector
            type={"larger"}
            key={"segment-distribution-site-selector-" + new Date().getTime()}
            websiteIdChanged={this.onWebSiteIdChanged.bind(this)}
            siteId={tagId ? tagId : websiteId}
            sites={client_sites}
            dayRangeChanged={setDateRange}
            dayRange={dayRange}
          />
        </div>
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <div id="left-nav" style={{ flex: "0 0 260px" }}>
            <div className="light-grey-border">
              <div
                style={{
                  height: "48px",
                  padding: "15px 20px",
                  position: "relative",
                  background: "#F5F5F5",
                }}
              >
                <strong>Page Insights</strong>
              </div>
              <div
                onClick={() => {
                  this.props.history.push(
                    "/distribution/pages/popular?tag=" + tagId + "&cid=" + cid,
                  );
                }}
                style={{ height: "58px", padding: "15px 20px " }}
                className={"distribution-type-active"}
              >
                Most Popular Pages
              </div>
              <div
                onClick={() => {
                  this.props.history.push(
                    (
                      "/distribution/pages/favorite" +
                      queryString.stringify(urlParams)
                    ).replace("%3F", "?"),
                  );
                }}
                style={{ height: "58px", padding: "15px 20px" }}
                className="distribution-type"
              >
                Favorite Pages
              </div>
            </div>
          </div>
          {(pageList && pageList.length > 0) || loadingPopularPages ? (
            <div
              id="report-main"
              className="ml-20 light-grey-border p-20"
              style={{ width: "100%", flex: "1 0" }}
            >
              <div>
                <h1 className="no-margin">
                  <strong>Most Popular Pages</strong>
                </h1>
              </div>
              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={{ flex: "1 1 420px" }}>
                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "10px",
                    }}
                  >
                    <strong>Popular page search</strong>
                  </div>
                  {/*
                  <Select
                    className="pop-pages-selector"
                    name=""
                    value={this.state.filter}
                    clearable={true}
                    options={pageList}
                    onChange={e => {
                      this.setState({ filter: e ? e.value : "" });
                    }}
                  />*/}
                  <input
                    type="text"
                    onChange={e => {
                      this.setState({ filter: e ? e.target.value : "" });
                    }}
                    style={{
                      width: "250px",
                      border: "solid 1px #BDBDBD",
                      marginTop: "5px",
                      marginLeft: "10px",
                      padding: "5px 10px",
                      lineHieght: "20px",
                    }}
                  />
                </div>
                <div style={{ flex: "1 1 200px", textAlign: "right" }}>
                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "0px",
                    }}
                  >
                    View
                  </div>
                  <Select
                    className="pop-pages-count-selector"
                    name=""
                    value={this.state.pageCount}
                    clearable={false}
                    searchable={false}
                    onChange={e => {
                      this.setState({ pageCount: e.value });
                    }}
                    options={[
                      { value: 20, label: "20" },
                      { value: 50, label: "50" },
                      { value: 100, label: "100" },
                    ]}
                  />
                  <div
                    style={{
                      display: "inline-block",
                      marginLeft: "20px",
                    }}
                  >
                    Popular Pages
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: "20px",
                  padding: "10px 20px 20px",
                  background: "#F5F5F5",
                  display: "flex",
                }}
              >
                <div style={{ width: "60%", paddingTop: "10px" }}>
                  <strong>Page Name</strong>
                </div>
                <div style={{ width: "20%", paddingTop: "10px" }}>
                  <strong>Total Visits</strong>
                </div>
                <div style={{ width: "18%", paddingTop: "10px" }}>
                  <strong>Add to Favorites</strong>
                </div>
              </div>
              <div
                style={{
                  height: "400px",
                  paddingTop: "150px",
                  textAlign: "center",
                  display:
                    loadingPopularPages || loadingPopularPagesError
                      ? "block"
                      : "none",
                }}
              >
                {loadingPopularPages && (
                  <h1 style={{ display: "inline-block" }}>
                    Data loading, Please waiting...
                  </h1>
                )}
                {loadingPopularPages && (
                  <img
                    src="/Spinner.gif"
                    style={{ marginLeft: "10px", height: "24px" }}
                  />
                )}
                {loadingPopularPagesError && (
                  <h3 style={{ color: "red" }}>
                    Can not load popular pages, {loadingPopularPagesError}
                  </h3>
                )}
              </div>
              <div
                style={{
                  overflowY: containerheight === "auto" ? "hidden" : "auto",
                  height: containerheight,
                  display:
                    loadingPopularPages || loadingPopularPagesError
                      ? "none"
                      : "block",
                }}
              >
                {map(filterPages, page => {
                  return [
                    <div
                      key={"page-" + page.pageUrl}
                      className={
                        !isUndefined(setFavoriteError) &&
                        this.state.errorKey === page.pageUrl
                          ? ""
                          : "light-grey-border-bottom"
                      }
                      style={{ padding: "10px 20px 20px", display: "flex" }}
                    >
                      <div
                        style={{
                          width: "60%",
                          paddingTop: "10px",
                          paddingRight: "20px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Link
                          to={
                            "/segment-distribution?cid=" +
                            cid +
                            "&tag=" +
                            tagId +
                            "&page=" +
                            page.pageUrl +
                            "&type=" +
                            type +
                            "&source=pop"
                          }
                        >
                          {isEmpty(this.state.filter) ? (
                            <span className="nav-clickable">
                              {page.pageUrl}
                            </span>
                          ) : (
                            <Highlighter
                              highlightClassName="clickable"
                              className="nav-clickable"
                              searchWords={[this.state.filter]}
                              autoEscape={true}
                              textToHighlight={page.pageUrl}
                            />
                          )}
                        </Link>
                      </div>
                      <div style={{ width: "20%", paddingTop: "10px" }}>
                        {splitNumber(page.totalVisits + "")()}
                      </div>
                      <div
                        style={{
                          width: "12%",
                          marginTop: "5px",
                          fontSize: "20px",
                          textAlign: "center",
                        }}
                      >
                        <i
                          className={
                            page.favorite
                              ? "fa fa-star clickable"
                              : "fa fa-star-o clickable"
                          }
                          style={{
                            color: page.favorite ? "#FFD700" : "#000000",
                          }}
                          onClick={() => {
                            this.setState({ errorKey: page.pageUrl });
                            this.props.setPageFavorite(
                              tagId,
                              this.props.dayRange,
                              page.pageUrl,
                              !page.favorite,
                            );
                          }}
                        />
                      </div>
                      <div style={{ width: "5%" }}>
                        {favoriting && this.state.errorKey === page.pageUrl && (
                          <img
                            src="/Spinner.gif"
                            style={{
                              height: "24px",
                              marginTop: "10px",
                            }}
                          />
                        )}
                      </div>
                    </div>,
                    <div
                      key={"page-favorite-error-" + page.pageUrl}
                      className={
                        isUndefined(setFavoriteError)
                          ? ""
                          : "light-grey-border-bottom pb-10"
                      }
                      style={{
                        width: "100%",
                        textAlign: "right",
                        paddingRight: "80px",
                        display:
                          page.pageUrl === this.state.errorKey
                            ? "block"
                            : "none",
                      }}
                    >
                      <span style={{ color: "red" }}>
                        {setFavoriteError && (
                          <AlertError
                            style={{
                              fill: "#DD0000",
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        )}{" "}
                        {setFavoriteError}
                      </span>
                    </div>,
                  ];
                })}
                {!isEmpty(this.state.filter) && isEmpty(filterPages) && (
                  <div className="light-grey-border-bottom text-center p-20">
                    No Results Found for "{this.state.filter}".Please try
                    another search.
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className="light-grey-border text-center p-20 ml-20 mb-20"
              id="contact-div"
              style={{
                color: "#DD0000",
                width: "100%",
                flex: "1 0",
                height: "400px",
                display: this.state.showEmptyError ? "block" : "none",
              }}
            >
              <AlertError
                style={{
                  fill: "#DD0000",
                  width: "16px",
                  height: "16px",
                }}
              />{" "}
              No data to display try a different date range
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default InsightPopularPagesIndex;



// WEBPACK FOOTER //
// ./src/components/Insights/page/PopularPages.jsx